export enum MODALS {
  LOGIN_MODAL = "login-modal",
  SIGNUP_MODAL = "signup-modal",
  PROFILE_MODAL = "profile-modal",
  SEARCH_CONTAINER = "search-container",
  SEARCH_RESULTS = "search-results",
  DISCIPLINES_DROPDOWN = "disciplines-dropdown",
  NEWSLETTER = "newsletter",
  CONTACT_FORM = "contact-form",
  TRAINING_FORM = "training-form",
  SERVICES_FORM = "services-form",
  KIT_FORM = "kit-form",
  PROMOTIONAL_MATERIAL_FORM = "promotional-material-form",
  POPUP_FORM = "popup-form",
  CONTACT_POPUP_FORM = "contact-popup-form",
  TRAINING_POPUP_FORM = "training-popup-form",
  SERVICES_POPUP_FORM = "services-popup-form",
  PODCASTS = "podcasts",
  COOKIES_POPUP = "cookies-popup",
  NONE = "",

  CONTACT_POPUP = "contact_popup",
  TRAINING_POPUP = "training_popup",
  SERVICES_POPUP = "services_popup",
}
